// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".notification[data-v-80c389a6] {\n  position: absolute;\n  bottom: 43px;\n  width: 100%;\n  border-radius: 0;\n}\n.notification[data-v-80c389a6]  .media-content {\n    text-align: center;\n}\n.notification.is-info[data-v-80c389a6] {\n    background-color: #01afb4;\n}\n.SideMenu__Footer[data-v-80c389a6] {\n  justify-content: space-between;\n}\n.New__Entity[data-v-80c389a6] {\n  height: 100vh;\n  display: flex;\n  flex-direction: column;\n}\n", ""]);
// Exports
module.exports = exports;
